module.exports = __webpack_public_path__ + "static/Exo_Diagram_Part02_sprite-90-0c29dc36af80c1d4f9777bef02567be6.png";